module.exports = __webpack_public_path__ + "media/packs/images/world-5e7861bec8f8b1bb82aa4c366482311c.svg";